import { render } from "./StaffDashboard.vue?vue&type=template&id=e329796c&scoped=true"
import script from "./StaffDashboard.vue?vue&type=script&lang=js"
export * from "./StaffDashboard.vue?vue&type=script&lang=js"

import "./StaffDashboard.vue?vue&type=style&index=0&id=e329796c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e329796c"]])

export default __exports__